import { useConfig } from '@gik/api/config/config';
import { useUserFirstNameJITCollect } from '../JITCollect/useUserFirstNameJITCollect';
import { useUserLastNameJITCollect } from '../JITCollect/useUserLastNameJITCollect';
import React from 'react';
import { IntercomIdentifier } from '@gik/analytics/hooks/IntercomIdentifier';
import { IntercomBooter } from '../IntercomLazyProvider/IntercomBooter';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';

function AppImportsComp() {
  // TODO: jitCollect, useConfig and intercom (and other things in _app e.g. UIWrapper, I18nextProvider) should be moved to a wrapper
  // that can be included by both nextjs and storybook
  useUserFirstNameJITCollect();
  useUserLastNameJITCollect();

  // this will retrieve config info about the app, and automatically update a user's refresh token
  // if their roles have changed
  useConfig();

  return (
    <>
      <IntercomBooter>
        <IntercomIdentifier />
      </IntercomBooter>
    </>
  );
}

export const AppImports = withComponentErrorBoundary(AppImportsComp);
